

const mergeOptions = require('merge-options');
const deepEqual = require('deep-equal');
const processError = require('./error-process');

function updateEntry(entry, data) {
  // Check whether any of the fields changed:
  let equal = true;

  for (const property in data.fields) {
    if (data.fields.hasOwnProperty(property)) {
      const value = data.fields[property];


      if (!entry.fields[property] || !deepEqual(entry.fields[property], value)) {
        equal = false;
        break;
        // console.log('field: ', property);
        // console.log('eprop: ', entry.fields[property]);
        // console.log('value: ', value);
        // console.log('entry: ', entry.fields);
        // console.log('data: ', data.fields);
      }
    }
  }

  // Nothing changed, skip update:
  if (equal) {
    return Promise.resolve(entry);
  }

  // Assign all field values to the entry:
  entry.fields = mergeOptions(entry.fields, data.fields);

  // Update fields that should not be merged but overwritten
  if (data.overwriteKeys) {
    data.overwriteKeys.forEach((overwriteKey) => {
      entry.fields[overwriteKey] = data.fields[overwriteKey];
    });
  }

  // Update entry:
  return entry.update().catch(
    processError
  );
}

module.exports = updateEntry;
